import React, { FC, useEffect, useState, useRef, Ref } from 'react';
import { LabelValidator } from './label-validador';
import { InputProps } from './props';
import { Container, StyledInput, StyledLabel } from './styles';

export const InputNumber: FC<InputProps> = ({
    label,
    value,
    color = '#47516f',
    isValid,
    style,
    onChange,
    ...rest
}) => {
    const ref: Ref<HTMLInputElement> = useRef(null);
    const [text, setText] = useState(value || '');
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.onfocus = () => setFocused(true);
            ref.current.onblur = () => setFocused(false);
        }
    }, [ref]);

    useEffect(() => {
        setText(value || '');
    }, [value]);

    return (
        <Container style={style}>
            <StyledInput
                {...rest}
                isValid={isValid}
                type='text' // text to ignore number css
                value={text}
                ref={ref}
                onChange={(ev: any) => {
                    const value = ev?.target.value;
                    if (
                        (!isNaN(parseFloat(value)) && isFinite(value)) ||
                        !value ||
                        value === ''
                    ) {
                        setText(ev.target.value), onChange?.(ev);
                    }
                }}
                placeholder=''
                pattern='\d+'
            />
            <StyledLabel active={focused || text !== ''}>{label}</StyledLabel>
            <LabelValidator isValid={isValid} />
        </Container>
    );
};
